import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type GetAddressPostcodeSuggestionQueryVariables = Types.Exact<{
    addressPartial: Types.Scalars['String'];
}>;

export type GetAddressPostcodeSuggestionQuery = { __typename?: 'Query' } & {
    getSuggestedAddresses?: Types.Maybe<
        { __typename?: 'AddressPostcodeSuggestion' } & {
            suggestions?: Types.Maybe<
                Array<
                    Types.Maybe<
                        { __typename?: 'SuggestedAddresses' } & {
                            address: Types.SuggestedAddresses['v'];
                            urlPath: Types.SuggestedAddresses['i'];
                        }
                    >
                >
            >;
            previousSuggestions?: Types.Maybe<
                Array<
                    Types.Maybe<
                        { __typename?: 'PastSuggestedAddresses' } & {
                            address: Types.PastSuggestedAddresses['v'];
                        }
                    >
                >
            >;
        }
    >;
};

export const GetAddressPostcodeSuggestionDocument = gql`
    query getAddressPostcodeSuggestion($addressPartial: String!) {
        getSuggestedAddresses(address: $addressPartial) {
            suggestions: g {
                address: v
                urlPath: i
            }
            previousSuggestions: p {
                address: v
            }
        }
    }
`;

/**
 * __useGetAddressPostcodeSuggestionQuery__
 *
 * To run a query within a React component, call `useGetAddressPostcodeSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressPostcodeSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressPostcodeSuggestionQuery({
 *   variables: {
 *      addressPartial: // value for 'addressPartial'
 *   },
 * });
 */
export function useGetAddressPostcodeSuggestionQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAddressPostcodeSuggestionQuery,
        GetAddressPostcodeSuggestionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAddressPostcodeSuggestionQuery,
        GetAddressPostcodeSuggestionQueryVariables
    >(GetAddressPostcodeSuggestionDocument, options);
}
export function useGetAddressPostcodeSuggestionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAddressPostcodeSuggestionQuery,
        GetAddressPostcodeSuggestionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAddressPostcodeSuggestionQuery,
        GetAddressPostcodeSuggestionQueryVariables
    >(GetAddressPostcodeSuggestionDocument, options);
}
export type GetAddressPostcodeSuggestionQueryHookResult = ReturnType<
    typeof useGetAddressPostcodeSuggestionQuery
>;
export type GetAddressPostcodeSuggestionLazyQueryHookResult = ReturnType<
    typeof useGetAddressPostcodeSuggestionLazyQuery
>;
export type GetAddressPostcodeSuggestionQueryResult = Apollo.QueryResult<
    GetAddressPostcodeSuggestionQuery,
    GetAddressPostcodeSuggestionQueryVariables
>;
